<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form
        :inline="true"
        size="small"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item label="课程目录名称">
          <el-input
            placeholder="请输入课程目录名称"
            v-model="formInline.search"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="课程">
          <el-select
            v-model="formInline.course_id"
            placeholder="请选择课程"
            @change="selectOne"
          >
            <el-option
              v-for="(item, index) in courseArr"
              :key="index"
              :label="item.name"
              :value="item.course_id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="课程目录">
          <el-select
            v-model="formInline.course_catalog_id"
            placeholder="请选择课程目录"
            @change="selectTwo"
          >
            <el-option
              v-for="(item, index) in courseCatalogArr"
              :key="index"
              :label="item.name"
              :value="item.course_catalog_id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button
        size="small"
        icon="el-icon-plus"
        type="primary"
        @click="addClick"
        >添加课时</el-button
      >
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table
            size="small"
            :data="tableData"
            border
            style="width: 100%"
            v-loading="loading"
          >
            <el-table-column prop="name" label="课时名称"></el-table-column>
            <el-table-column prop="address" label="视频地址"></el-table-column>
            <el-table-column label="视频封面">
              <template slot-scope="scope">
                <img
                  v-if="scope.row.image && scope.row.image.length > 0"
                  :src="scope.row.image[0].file_path"
                  alt="视频封面"
                  style="width: 100px; height: auto;"
                />
              </template>
            </el-table-column>
            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
              width="150"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button
                  @click="editClick(scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  @click="deleteClick(scope.row)"
                  type="text"
                  size="small"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add
      :open_add="open_add"
      v-if="open_add"
      @close="closeAdd"
      :course_catalog_id="formInline.course_catalog_id"
    ></Add>
    <Edit
      :open_add="open_edit"
      :course_period_id="course_period_id"
      v-if="open_edit"
      @close="closeEdit"
    ></Edit>

    <el-dialog
      style="text-align: center"
      title="设置标题"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
    >
    </el-dialog>
  </div>
</template>

<script>
import CoursePeriodApi from "@/api/course_period.js";
import Course_catalogApi from "@/api/course_catalog.js";
import CourseApi from "@/api/course.js";
import Add from "./part/add.vue";
import Edit from "./part/edit.vue";

export default {
  components: {
    Add,
    Edit
  },
  inject: ["reload"],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*搜索表单对象*/
      form: {},
      formInline: {
        search: "",
        course_catalog_id: 0,
        courseArr: []
      },

      open_add: false,
      open_edit: false,
      course_period_id: "",
      dialogVisible: false
    };
  },
  created() {
    /*获取列表*/
    this.getCourse();
    this.getCourseCatalog();
  },
  methods: {
    getCourse() {
      let self = this;
      let Params = {};
      self.loading = true;
      CourseApi.listx(Params, true)
        .then(data => {
          self.loading = false;
          self.courseArr = data.data;
          self.formInline.course_id = self.courseArr[0].course_id;

          this.getTableList();
        })
        .catch(error => {});
    },
    getCourseCatalog() {
      let self = this;
      let Params = {};
      self.loading = true;
      Params.course_id = self.formInline.course_id;
      Course_catalogApi.listx(Params, true)
        .then(data => {
          self.loading = false;
          self.courseCatalogArr = data.data;
          self.formInline.course_catalog_id =
            self.courseCatalogArr[0].course_catalog_id;
          self.tableData = [];
          this.getTableList();
        })
        .catch(error => {});
    },

    selectOne() {
      let self = this;
      self.courseCatalogArr = [];
      self.formInline.course_catalog_id = 0;
      self.getCourseCatalog();
    },
    selectTwo() {
      this.getTableList();
    },

    dialogFormVisible() {
      this.dialogVisible = false;
    },
    setting(e) {
      //课程目录标题设置
      // this.categorya_id = e
      this.dialogVisible = true;
    },
    /*关闭添加*/
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    getData() {
      this.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.course_catalog_id = self.formInline.course_catalog_id;
      self.loading = true;
      CoursePeriodApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*添加任务*/
    addClick() {
      this.open_add = true;
    },

    /*编辑活动*/
    editClick(row) {
      this.course_period_id = row.course_period_id;
      this.open_edit = true;
    },

    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          CoursePeriodApi.del(
            {
              course_period_id: row.course_period_id
            },
            true
          )
            .then(data => {
              if (data.code == 1) {
                self.$message({
                  message: "删除成功",
                  type: "success"
                });
                this.getTableList();
              } else {
                self.$message.error("错了哦，这是一条错误消息");
              }
            })
            .catch(error => {});
        })
        .catch(() => {});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/course_catalog/course_period/index.vue